module.exports = {"AwsApiGatewayInvokeUrl":"https://cr8d5fpamb.execute-api.us-east-1.amazonaws.com/prod","UserPoolId":"us-east-1_wTtQ9ZpVz","UserPoolClientId":"2sklqdal6ds1vnm1omofbtla0q","IdentityPoolId":"us-east-1:c1a1fbfe-6074-46d1-b113-dce1d4ff8e32","AwsIotHost":"ab6yikssb67vb-ats.iot.us-east-1.amazonaws.com","AwsRegion":"us-east-1","LogLevel":"silent","MqttDebugLevel":"false","FacebookAppId":"not_configured","GoogleAppId":"393429044090-qa7oein50aa0cv88uce49p6926jj9hsh.apps.googleusercontent.com"}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 1213
// module chunks = 0